<template>
  <section class="error-popup">
    <div class="popup-wrapper" @click.stop.prevent="goToChat">
      <div class="popup-body d-inline">{{ globalMessage }}</div>
      <div class="popup-footer d-inline float-right">
        <a @click.stop.prevent="clearGlobalMessage" href="#">CLOSE</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      globalMessage: "getGlobalMessage",
      globalMessageAction: "getGlobalMessageAction"
    })
  },
  methods: {
    ...mapActions({
      clearGlobalMessage: "clearGlobalMessage"
    }),

    ...mapMutations("portalemail", {
      resetStateForOtherUser: "resetStateForOtherUser",
      setSelectedUserId: "setSelectedUserId"
    }),

    goToChat() {
      if (this.globalMessageAction) {

        if(this.globalMessageAction.includes('/emails/')) {
          this.resetStateForOtherUser();
          this.setSelectedUserId(0);
        }

        this.$router.push(this.globalMessageAction);
        this.clearGlobalMessage();
      }
    }
  }
};
</script>

<style scoped>
section {
  margin-top: 103px;
  margin-bottom: 45px;
}

.error-popup {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  margin-top: 0px;
  z-index: 99999;
  margin-bottom: 0px;
}
.error-popup .popup-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #444;
  width: 100%;
  box-shadow: 4px 16px 37px 15px #555454;
  font-size: 13px;
  padding: 20px;
  box-sizing: border-box;
}
.error-popup .popup-wrapper .popup-body {
  display: flex;
  flex-wrap: wrap;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 100;
  color: #fff;
}
.error-popup .popup-wrapper .popup-footer {
  margin-top: 2px;
  font-size: 15px;
}
</style>
